import template from './rz-profil-feld.html.twig';
import './rz-profil-feld.scss';

const { Component } = Shopware;

/**
 * Das Geschmacksprofil als sechs Regler statt als JSON.
 *
 * Vorher stand in dem Feld "[object]" – ein Textfeld kann ein Objekt nicht
 * darstellen, und niemand konnte die Werte ändern.
 *
 * Die Achsen stehen hier fest, weil sie auch im Theme und im Aromenberater
 * fest stehen: wer eine hinzufügt, muss beide Stellen mitziehen
 * (RiccardoAdvisor\Core\Advisor\ProfileExtractor::AXES und die Achsenliste
 * in cms-element-product-description-reviews.html.twig).
 */
const ACHSEN = [
    { schluessel: 'fruchtig', name: 'Fruchtig' },
    { schluessel: 'suess', name: 'Süß' },
    { schluessel: 'frisch', name: 'Frisch & kühl' },
    { schluessel: 'saeuerlich', name: 'Säuerlich' },
    { schluessel: 'cremig', name: 'Cremig' },
    { schluessel: 'wuerzig', name: 'Würzig & herb' },
];

Component.register('rz-profil-feld', {
    template,

    props: {
        value: { type: Object, required: false, default: null },
        disabled: { type: Boolean, required: false, default: false },
    },

    data() {
        return { achsen: ACHSEN };
    },

    computed: {
        werte() {
            const roh = this.value && typeof this.value === 'object' ? this.value : {};
            const werte = {};
            ACHSEN.forEach(({ schluessel }) => {
                const zahl = Number.parseInt(roh[schluessel], 10);
                werte[schluessel] = Number.isFinite(zahl) ? Math.min(5, Math.max(0, zahl)) : 0;
            });
            return werte;
        },

        istLeer() {
            return Object.values(this.werte).every((w) => w === 0);
        },
    },

    methods: {
        setze(schluessel, zahl) {
            const werte = { ...this.werte, [schluessel]: Math.min(5, Math.max(0, Number(zahl) || 0)) };

            // Nur gesetzte Achsen speichern: eine Null bedeutet "kommt nicht
            // vor" und muss nicht in den Daten stehen. Sind alle null, wird
            // das Feld geleert – dann zeigt die Artikelseite kein Profil.
            const sauber = {};
            Object.entries(werte).forEach(([k, v]) => { if (v > 0) sauber[k] = v; });

            this.$emit('update:value', Object.keys(sauber).length ? sauber : null);
        },

        leeren() {
            this.$emit('update:value', null);
        },
    },
});
